import { useBreakPoints } from 'core/Hooks';

import { Referrals } from '../../pages/Referrals/Referrals';

// May be more join routes in the future so this route file handles those considerations
export const JoinRoutes = () => {
  const { isMobile } = useBreakPoints();
  // Want to allow the mobile route to persist, but on desktop we'll render nothing since the drawer is going to be on top
  return isMobile ? <Referrals.Cause /> : null;
};
